module.exports = __webpack_public_path__ + "img/infinity_st_all_platforms.719cf0c6.jpg";